const DEFAULT_ERROR_MESSAGE = 'Request failed';

export function getErrorMessage(
  error: unknown,
  fallback = DEFAULT_ERROR_MESSAGE,
): string {
  if (typeof error === 'string') {
    return error;
  }

  if (error instanceof Error) {
    return error.message || fallback;
  }

  if (error && typeof error === 'object') {
    const { message, response } = error as {
      message?: unknown;
      response?: { data?: { message?: unknown } };
    };

    if (typeof message === 'string' && message.length > 0) {
      return message;
    }

    const responseMessage = response?.data?.message;
    if (typeof responseMessage === 'string' && responseMessage.length > 0) {
      return responseMessage;
    }
  }

  return fallback;
}
